import { css } from '@emotion/core';
import { applyFont, tokens } from '@domain-group/fe-brary';
var colors = tokens.colors,
  spacing = tokens.spacing,
  typography = tokens.typography;
export var sideboxCard = /*#__PURE__*/css("display:flex;flex-direction:column;width:320px;border:1px solid ", colors.neutral.trim.default, ";border-radius:5px;");
export var agencyBranding = backgroundColour => /*#__PURE__*/css("display:flex;justify-content:center;padding:8px 0;background-color:", backgroundColour || 'transparent', ";");
export var logo = {
  name: "1fixb3k",
  styles: "height:36px;max-height:36px;"
};
export var body = {
  name: "g5nfir",
  styles: "display:flex;flex-direction:column;gap:16px;padding:16px;"
};
export var profile = /*#__PURE__*/css("display:flex;flex-direction:column;align-items:center;gap:", spacing.s, ";");
export var avatar = {
  name: "1kw7226",
  styles: "width:128px;height:128px;"
};
export var details = {
  name: "dvxtzn",
  styles: "display:flex;flex-direction:column;align-items:center;"
};
export var name = /*#__PURE__*/css(applyFont(typography.displaySmall), " color:", colors.neutral.heavy.default, ";");
export var title = /*#__PURE__*/css(applyFont(typography.body), " color:", colors.neutral.heavy.default, ";text-decoration:none;");
export var buttons = {
  name: "g0y3ck",
  styles: "display:flex;flex-direction:column;justify-content:center;gap:12px;"
};
export var callButton = /*#__PURE__*/css(applyFont(typography.bodyBold), " color:", colors.neutral.heavy.default, ";");